import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-torno',
  templateUrl: './torno.component.html',
  styleUrls: ['./torno.component.css']
})
export class TornoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
